<script>
    import {navigate} from "svelte-routing";
    import {onMount} from 'svelte';
    import {POST, GET} from "../components/communication";

    export let openDoor;
    let singleVisitCode = {}
    let systemStatus = false;
    let loadingSpinner = {
        useCode: false
    };

    onMount(async function () {
        checkSystemStatus();
    });

    // Tarkista systeein status
    async function checkSystemStatus() {
        const response = GET('/C/checkSystemStatus');
        const data = await response;
        if (data && data.status === "OK") {
            systemStatus = true;
            console.log("Onnistui :: System status: ", systemStatus);
        } else {
            console.log("VIRHE :: data: ", data);
            systemStatus = false;
        }
    }

    // Käytä kertakäynti
    async function submitCode() {
        loadingSpinner.useCode = true;
        const tempCode = singleVisitCode;
        console.log("submitCode: ", tempCode);

        const response = POST("/useCode", JSON.stringify(tempCode));
        const data = await response;
        if (data && data.code === "OK") {
            console.log("Kertakäynti käytettiin: ", data);
            navigate('/koodikaytetty', {replace: false});
        } else {
            alert("Jotain meni pieleen. Päivitä sivu ja kokeile uudestaan.");
        }
        loadingSpinner.useCode = false;
    }

</script>
<div class="page">
    <div class="container">
        {#if loadingSpinner.useCode}
            <div class="row">Tarkistetaan koodia... </div>
            {:else}
        <div class="row">
            {#if openDoor}
                <div class="col-xs-12 col-md-12">
                    <h3>Tervetuloa Dynamosalille!</h3>
                    <p>Ovi avattiin ja se pysyy auki n. 30 sekuntia!.</p>
                    <p>Jätä ulkokengät heti oven vasemmalle puolelle kenkätelineisiin.</p>
                    <p>Pukuhuoneet löytyvät ulko-ovelta katsottuna oikealta puolelta.</p>
                    <p>Tsemppiä treeniin!.</p>
                    <p>(Voit sulkea tämän selainikkunan.)</p>
                </div>
            {:else}
                {#if systemStatus}
                    <div class="col-xs-12 col-md-7">
                        <h2>Tervetuloa Dynamosalille!</h2>
                        <h3>Avaa ovi saamallasi PIN-koodilla</h3>
                        <p>Syötä PIN-koodi ja ja klikkaa ovi auki, <b>kun olet oven läheisyydessä</b>. Ovi pysyy auki n. 30
                            sekuntia.</p>
                        <form on:submit|preventDefault={submitCode}>
                            <input class="form-control" required type="text" id="code" placeholder="Syötä saamasi PIN-koodi tähän."
                                   bind:value={singleVisitCode.code}/>
                            <button type="submit" class="btn btn-primary">Avaa ovi</button>
                        </form>
                    </div>
                {/if}
                <div class="col-xs-12 col-md-5">
                    <div class="card">
                        <div class="card-body">
                            <p>PIN-koodi on käytettävissä joka päivä klo: 07 - 21. </p>
                            <p>PIN-koodin syötö on:
                                {#if systemStatus} <b class="kaytossa">Käytettävissä</b>
                                {:else}<b class="kaytossa">Poissa käytöstä!</b>{/if}
                            </p>
                            <p>Mikäli kohtaat ongelmia PIN-koodin käytössä klo: 07-21 välissä, ole yhteydessä: <br>
                            Markus 0500 130 130 tai <br>
                            Petteri 041 4337 877</p>
                            {#if !systemStatus}
                                <button on:click|preventDefault={() => checkSystemStatus()}>Tarkista uudestaan</button>
                            {/if}
                        </div>
                    </div>


                </div>
            {/if}
        </div>
        {/if}
    </div>
</div>
